const PromoCodes = require("./containers/PromoCodes");
const AuthenticateAdmin = require("../utils").authenticateAdmin;

// Sync route definition
module.exports = {
    path: "/admin/promocodes/edit/:id",
    component: AuthenticateAdmin(PromoCodes),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-edit/index.js